import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: []
  },
  reducers: {
    addToCart: (state, action) => {
      state.items = [...state.items, action.payload];
    },
    removeFromCart: (state, action) => {
      const existingItem = state.items.find(item => item.dimension.id === action.payload.dim_id && item.material === action.payload.material);

      if (existingItem) {
        state.items = state.items.filter(item => item !== existingItem);
      }
    },
    updateCartQuantity: (state, action) => {
      const newQuantity = action.payload.quantity;
      const existingItem = state.items.find(item => item.dimension.id === action.payload.dim_id && item.material === action.payload.material);
        
      if (existingItem) {
        existingItem.quantity = newQuantity;
      }
    },
    clearCart: (state) => {
      state.items = [];
    }
  }
});

export const { addToCart, removeFromCart, updateCartQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
